import DerivativesStrategiesPreview from "../strategies/strategies-preview/DerivativesStrategiesPreview";
import {Paper} from "@mui/material";

const DerivativesStockOption = () => {
    return (
        <Paper>
          <DerivativesStrategiesPreview
              url="/dashboard/derivatives/stock-option/strategies"
          />
        </Paper>
    );
};

export default DerivativesStockOption;
